import React from 'react'
import { connect } from 'react-redux'
import { Interface } from '@leverege/api-redux'
import { ResourceUsersScreen } from '@leverege/api-ui-user-management'
import { DeviceActions } from '../../actions'

class DeviceUsersScreen extends React.Component {

  componentDidMount() {
    const { match : { params }, dispatch } = this.props
    const { systemId, deviceId, blueprintId } = params
    if ( !blueprintId ) {
      dispatch( DeviceActions.getDevice( systemId, deviceId ) )
    }
  }

  render() {
    const { match : { params }, device } = this.props
    const { projectId, systemId, deviceId, blueprintId } = params

    if ( !blueprintId && !device?.blueprintId ) {
      return null
    }

    return (
      <ResourceUsersScreen
        allowApiAccess
        selectorProps={{ simple : false }} 
        projectId={projectId} 
        resourceId={deviceId}
        systemId={systemId}
        actions={Interface.create( systemId, blueprintId || device?.blueprintId ).obj( deviceId )}/>
    )
  }
} 

export default connect(
  ( state, props ) => ( {
    device : state.devices?.lookup?.[props?.match?.params?.deviceId],
  } )
)( DeviceUsersScreen );
